import { ConfigRecord } from "./ConfigRecord";
import * as GlobalTypes from "../../types";
import { DesiredStateItem } from "./DesiredState";
import * as uuid from 'uuid';

export type ThemeMacrosRecord = ConfigRecord<ThemeMacrosConfig>;
export type ThemeMacrosConfig = ThemeMacroItem[];

export class ThemeMacroItem {
    UUID: GlobalTypes.UUIDV4;
    Name: string;
    Icon: GlobalTypes.IconDefinition;
    //Type: string;
    Themes: DesiredStateItem[];
}